import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import Img from 'gatsby-image'

const LogoHeader = () => {

    const data = useStaticQuery(graphql`
    query HeaderQuery {
        file(relativePath: {eq: "logo_secundario.png"}) {
          childImageSharp {
            fixed (width: 150){
                ...GatsbyImageSharpFixed
            }
          }
        }
      }`
    )

    return (
        <Link to="/" className="logo">
            <Img
                fixed={data.file.childImageSharp.fixed}
                alt="LogoRN"
                style={{ marginTop: '0.625em' }}
                imgStyle={{ objectFit: 'contain' }}
            />
        </Link>
    )
}

LogoHeader.defaultProps = {
    goBackBtn: true
}
export default LogoHeader
